/**
 * The library version of patreon-api.ts
 */
// x-release-please-start-version
export const VERSION = '0.14.2'
// x-release-please-end